"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
function SortMenu(props) {
  var options = reconnect_js_1.useOutlet(props.sortOptions)[0];
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var sort = props.sort,
    updateSort = props.updateSort;
  var selectedOption = options.find(function (opt) {
    return opt.name === sort;
  });
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("label", {
    style: {
      margin: 10,
      marginLeft: 0
    }
  }, AppActions.L('sort')), react_1.default.createElement("div", {
    style: {
      marginRight: 10
    }
  }, react_1.default.createElement(antd_1.Dropdown, {
    overlay: react_1.default.createElement(antd_1.Menu, null, options.map(function (option) {
      return react_1.default.createElement(antd_1.Menu.Item, {
        key: option.name,
        onClick: function onClick() {
          updateSort(option.name);
        }
      }, option.display);
    }))
  }, react_1.default.createElement("div", {
    style: {
      padding: '4px 11px'
    }
  }, selectedOption && selectedOption.display || AppActions.L('select')))));
}
exports.default = SortMenu;